import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_123: DocMigration = {
  maxSchemaVersion: "0.0.123",
  description: "New wrap frieze board modes.",
  apply(json: any) {
    const { settings: allSettings, roofs } = json;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.wrapFriezeBoards !== undefined) {
        settings.wrapFriezeBoardMode = settings.wrapFriezeBoards ? "FULL" : "NONE";
        delete settings.wrapFriezeBoards;
      }
    }

    for (const roofId in roofs) {
      const roof = roofs[roofId];

      if (roof.wrapFriezeBoards !== undefined) {
        roof.wrapFriezeBoardMode = roof.wrapFriezeBoards ? "FULL" : "NONE";
        delete roof.wrapFriezeBoards;
      }
    }

    return json;
  },
};

export default migration_0_0_123;
